import { Component } from '@angular/core'
import { User } from '../../models';
import { Router } from '@angular/router';
import { SSOUtility } from '../../util/sso.utility';
import { AgentUtility } from '../../util';

@Component({
    moduleId: module.id,
    selector: 'access-denied',
    templateUrl: 'access-denied.html'
})
export class AccessDeniedComponent {

    constructor(private router: Router) { }

    ngOnInit() {
    }

    reLogin(){
        this.deleteUrl();
        SSOUtility.signOut();
    }

    deleteUrl(){
        let newUrl = document.location.href.replace(AgentUtility.ACCESS_DENIED,"")
        window.history.pushState({"html":document.body.innerHTML,"pageTitle":document.title},"", newUrl);
    }
}